import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Inject, Injectable, Type } from '@angular/core';
import { DIALOG_COMPONENTS } from '../tokens/dialog-components.token';
import { Track } from '../models/track.model';
import { TrackVersion } from '../models/trackversion.model';
import { Observable } from 'rxjs';

import { Filters, TrackService } from './track.service';
import { PlaylistFolder } from '../models/playlistfolder.model';
import { Playlist } from '../models/playlist.model';
import { User } from '../models/user.model';
import { EmailGroup } from '../models/email-group.model';
import { EmailTemplate } from '../models/email-template.model';
import { TrackInfo } from '../models/trackinfo.model';
import { environment } from 'src/environments/environment';
import { map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {BehaviorSubject}  from 'rxjs'


@Injectable({
  providedIn: 'root'
})
export class DialogService {
  dataTab: any[] = [];

  public dialogRefresh: BehaviorSubject<string> = new BehaviorSubject('');


  constructor(
    public dialog: MatDialog, private http: HttpClient, private _trackService: TrackService,
    // Component classes arrive through the token rather than direct imports - see
    // dialog-components.token.ts for why. Keys are the class names verbatim.
    @Inject(DIALOG_COMPONENTS) private components: Record<string, Type<any>>
  ) {
  }

  displayTrackInfo(track: any, version: any, type:any=''): Observable<void> {
      this._trackService.getComposerDetails(version.id).subscribe(opt => {
        track = opt
        version = opt
        this.dataTab = opt['composer_details'];
        if (this.dataTab.length > 0) { 
          const dialog = this.dialog.open(this.components.TrackInfoComponent, {
            autoFocus: true,
            closeOnNavigation: true,
            width: '708px',
            maxHeight: '100%',
            panelClass: 'no-padding-dialog',
            data: {track: track, version: version, response: this.dataTab, composers: opt,type:type}
          });
          return dialog.afterClosed();
        }
      }, (error) => {
        console.log(error);
      });
      return ;
  }

  displayDeleteTrackVersionDialog(track: Track, version: TrackVersion): Observable<boolean> {

    const dialog = this.dialog.open(this.components.DeleteTrackVersionDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {
        track: track,
        version: version
      }
    });
    return dialog.afterClosed();

  }
  displayDetailTrackVersionDialog(track: Track, version: TrackVersion,opt: any): Observable<boolean> {
  const dialog = this.dialog.open(this.components.TrackDetailsComposerComponent, {
    autoFocus: true,
    closeOnNavigation: true,
    width: '708px',
    maxHeight: '100%',
    panelClass: 'no-padding-dialog',
    data: {track: track, version:version, response: this.dataTab, composers: opt}
  });
  return dialog.afterClosed();
}

  displayExportOptionsDialog(): Observable<void> {
    const dialog = this.dialog.open(this.components.ExportOptionsDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { }
    });
    return dialog.afterClosed();
  }

  displayNewPlaylistDialog(): Observable<Playlist> {
    const dialog = this.dialog.open(this.components.DuplicatePlaylistDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { playlist: null, isDuplicate: false, isEdit: false }
    });
    return dialog.afterClosed();
  }
  

  displayDuplicatePlaylistDialog(playlist: Playlist): Observable<Playlist> {
    const dialog = this.dialog.open(this.components.DuplicatePlaylistDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { playlist: playlist, isDuplicate: true, isEdit: false }
    });
    return dialog.afterClosed();
  }

  displayEditPlaylistDialog(playlist: Playlist): Observable<Playlist> {
    const dialog = this.dialog.open(this.components.DuplicatePlaylistDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { playlist: playlist, isDuplicate: false, isEdit: true }
    });
    return dialog.afterClosed();
  }

  displayNewPlaylistFolderDialog(): Observable<PlaylistFolder> {
    const dialog = this.dialog.open(this.components.NewPlaylistFolderDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { folder: null, isEdit:false }
    });
    return dialog.afterClosed();
  }
  displayConfirmPopup(title:any, val:any): Observable<any> {
    const dialog = this.dialog.open(this.components.ConfirmPopupComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {title:title, val:val }
    });
    return dialog.afterClosed();
  }
  displayCampaignSendDialog(data: {
    campaignId?: string;
    templateId?: number;
    fromEmail?: string;
    subject?: string;
    body?: string;
    recipientGroupIds?: number[];
    explicitRecipientEmails?: string[];
    cc?: string[];
    bcc?: string[];
  }): Observable<boolean> {
    const dialog = this.dialog.open(this.components.CampaignSendDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '960px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: 'no-padding-dialog',
      data: data
    });
    return dialog.afterClosed();
  }

  DuplicateConfirmPopup(title:any): Observable<any> {
    const dialog = this.dialog.open(this.components.DuplicatetemplatePopupComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '508px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {title:title}
    });
    return dialog.afterClosed();
  }
  SupportUserPopup(title:any): Observable<any> {
    const dialog = this.dialog.open(this.components.SupportUserInputComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '508px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {title:title}
    });
    return dialog.afterClosed();
  }
  UserUploadPopupConfirmPopup(title:any, value:any=''): Observable<any> {
    const dialog = this.dialog.open(this.components.UserUploadPopupComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {title:title, value:value}
    });
    return dialog.afterClosed();
  }

  UserUploadPopup_NoConfirm(title:any, value:any=''){
    const dialog = this.dialog.open(this.components.UserUploadPopupComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {title:title, value:value}
    });
  
    //closes after 3 seconds
    setTimeout(() => {
      this.dialog.closeAll();
    }, 3000);

  }

  displayEditPlaylistFolderDialog(folder: PlaylistFolder): Observable<PlaylistFolder> {
    const dialog = this.dialog.open(this.components.NewPlaylistFolderDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { folder: folder, isEdit:true }
    });
    return dialog.afterClosed();
  }

  displayAddRemovePlaylistDialog(playlist: Playlist,folderId:number[],playListfolder:PlaylistFolder[],tabval:string): Observable<boolean> {
    const dialog = this.dialog.open(this.components.AddRemovePlaylistDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { playlist: playlist,folderId:folderId,playListfolder:playListfolder ,tabval:tabval}
    });
    return dialog.afterClosed();
  }

  displayDownloadResultsDialog(filters: Filters, trackCount: number): Observable<void> {
    const dialog = this.dialog.open(this.components.DownloadResultsDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { filters:filters, trackCount:trackCount }
    });
    return dialog.afterClosed();
  }

  displayDeletePlaylistDialog(playlist: any, id:any='', type:any='', data:any=[]): Observable<boolean> {
    const dialog = this.dialog.open(this.components.DeletePlaylistDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { playlist: playlist , id:id, type:type,data:data}
    });
    return dialog.afterClosed();
  }

  displayDeletePlaylistFoldersDialog(folders: PlaylistFolder[]): Observable<boolean> {
    const dialog = this.dialog.open(this.components.DeletePlaylistFoldersDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { folders: folders }
    });
    return dialog.afterClosed();
  }

  displayRemoveTrackDialog(track: Track): Observable<void> {
    const dialog = this.dialog.open(this.components.RemoveTrackDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { track: track }
    });
    return dialog.afterClosed();
  }

  displayManageTracksClientsDialog(playlist: any, val: String): Observable<boolean> {
    const dialog = this.dialog.open(this.components.ManageTracksClientsDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { playlist: playlist, val:val }
    });
    return dialog.afterClosed();
  }

  displayAddSongPlaylistDialog(track: Track, version: TrackVersion,trackid:any): Observable<boolean> {
    var matDialogConfig: MatDialogConfig = {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
    };
   
    const dialogConfig = matDialogConfig;
    dialogConfig. data= {
      track: track,
      version: version,
      trackid:trackid
    }
    const dialog = this.dialog.open(this.components.AddSongPlaylistDialogComponent, dialogConfig);
    return dialog.afterClosed();
  }
  displayAddTrackPlaylistDialog(track: Track, version: TrackVersion,list:any, trackid:any): Observable<boolean> {
    var matDialogConfig: MatDialogConfig = {
      position: {
        right: '2px',
        top: '0px',
      },
      width: '600px',
      height:'100%',
      autoFocus: true,
      closeOnNavigation: true,
    };
    const dialogConfig = matDialogConfig;
    dialogConfig. data= {
      track: track,
      version: version,
      list:list,
      trackid:trackid
    }
    const dialog = this.dialog.open(this.components.AddTrackPlaylistDialogComponent, dialogConfig);
    return dialog.afterClosed();
  }

  displayAddToEmailGroupDialog(users: User[], from_page: any): Observable<boolean> {

    const dialog = this.dialog.open(this.components.AddToEmailGroupComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {
        users: users,
        from_page: from_page
      }
    });
    return dialog.afterClosed();
  }

  displayManageUserPlaylistsDialog(user: User): Observable<boolean> {

    const dialog = this.dialog.open(this.components.ManageUserPlaylistsComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {
        user: user,
      }
    });
    return dialog.afterClosed();
  }

  displayClientActivityDialog(user: User): Observable<boolean> {

    const dialog = this.dialog.open(this.components.ClientActivityDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {
        user: user,
      }
    });
    return dialog.afterClosed();
  }

  displayDeleteClientDialog(user: User, isArtist: boolean = false): Observable<boolean> {

    const dialog = this.dialog.open(this.components.DeleteClientDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {
        user: user,
        isArtist: isArtist
      }
    });
    return dialog.afterClosed();

  }

  displayArtistActivityDialog(user: User): Observable<boolean> {

    const dialog = this.dialog.open(this.components.ArtistActivityDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {
        user: user,
      }
    });
    return dialog.afterClosed();
  }


  displayNewUserEmailGroupDialog(name:string = '', isDuplicate:boolean = false, id:number=0): Observable<boolean> {

    const dialog = this.dialog.open(this.components.NewUserEmailGroupComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {
        name: name,
        isDuplicate: isDuplicate,
        id:id
      }
    });
    return dialog.afterClosed();
  }

  displayRemoveUsersFromEmailGroupDialog(users:User[] = [], groupId:number): Observable<boolean> {

    const dialog = this.dialog.open(this.components.RemoveUsersFromEmailGroupComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {
        users: users,
        groupId: groupId
      }
    });
    return dialog.afterClosed();

  }

  displayDeleteUserEmailGroupDialog(group:EmailGroup): Observable<boolean>{
  
    const dialog = this.dialog.open(this.components.DeleteUserEmailGroupComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {
        group: group
      }
    });
    return dialog.afterClosed();

  }

  displayNewEmailTemplateDialog(template:EmailTemplate =null, isDuplicate: boolean = false, type:string): Observable<boolean> {
    
    const dialog = this.dialog.open(this.components.NewEmailTemplateDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {
        template: template,
        isDuplicate: isDuplicate,
        type:type
      }
    });
    return dialog.afterClosed();
  }

  displayDeleteEmailTemplateDialog(template:EmailTemplate): Observable<boolean>{

    const dialog = this.dialog.open(this.components.DeleteEmailTemplateDialogComponent, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {
        template: template
      }
    });
    return dialog.afterClosed();
  }

  displayDeleteUsergroupDialog(data): Observable<boolean>{

    const dialog = this.dialog.open(data, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { }
    });
    return dialog.afterClosed();
  }
  displayMenuDialog(data, type:any=''): Observable<boolean>{

    const dialog = this.dialog.open(data, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '708px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: {type:type}
    });
    return dialog.afterClosed();
  }
  displayMenuDialogAlert(data, disable, val): Observable<boolean>{

    const dialog = this.dialog.open(data, {
      autoFocus: true,
      closeOnNavigation: true,
      width: '500px',
      maxHeight: '100%',
      panelClass: 'no-padding-dialog',
      data: { disable: disable , error:val}
    });
    return dialog.afterClosed();
  }
}
